// @flow
import React, { Component } from 'react';
import { MdClose, MdLink, MdShare } from 'react-icons/md';
import { FaFacebookSquare, FaTwitter } from 'react-icons/fa';
import { copyText, shareFacebook, shareTwitter } from 'lib/share';
import cx from 'classnames';
import './PartnerMobileShare.scss';

type Props = {
  url: string,
  title: string,
  username: string,
  informCopy: () => void,
};
type State = {
  open: boolean,
  animating: boolean,
};

class PartnerMobileShare extends Component<Props, State> {
  animateTimeoutId = null;

  state = {
    open: false,
    animating: false,
  };

  onToggle = () => {
    this.setState({
      open: !this.state.open,
      animating: true,
    });
    if (this.animateTimeoutId) {
      clearTimeout(this.animateTimeoutId);
    }
    setTimeout(() => {
      this.setState({
        animating: false,
      });
    }, 150);
  };

  onFacebookShare = () => {
    this.onToggle();
    shareFacebook(`${process.env.BASE_URL}${this.props.url}`);
  };

  onTwitterShare = () => {
    this.onToggle();
    shareTwitter(
      `${process.env.BASE_URL}${this.props.url}`,
      `${this.props.username}님이 등록하신 "${this.props.title}" 파트너를 둘러보세요.`,
    );
  };

  onCopy = () => {
    this.onToggle();
    copyText(`${process.env.BASE_URL}${this.props.url}`);
    this.props.informCopy();
  };

  componentWillUnmount() {
    if (this.animateTimeoutId) {
      clearTimeout(this.animateTimeoutId);
    }
  }

  render() {
    const { open, animating } = this.state;

    const transition = (() => {
      if (!animating) return '';
      if (open) return 'appear';
      return 'disappear';
    })();

    return (
      <div className="PartnerMobileShare">
        {(open || animating) && (
          <div className={cx('buttons', transition)}>
            <button onClick={this.onFacebookShare}>
              <FaFacebookSquare />
            </button>
            <button onClick={this.onTwitterShare}>
              <FaTwitter />
            </button>
            <button onClick={this.onCopy}>
              <MdLink />
            </button>
          </div>
        )}
        <button className={cx({ open: this.state.open })} onClick={this.onToggle}>
          {this.state.open ? <MdClose /> : <MdShare />}
        </button>
      </div>
    );
  }
}

export default PartnerMobileShare;



// WEBPACK FOOTER //
// ./src/components/partner/PartnerMobileShare/PartnerMobileShare.js